// extracted by mini-css-extract-plugin
export var dropdownButton = "_1g-0";
export var fullWidthDropdownButton = "_1g-1";
export var icon = "_1g-3";
export var iconPlaceholder = "_1g-2";
export var menuItemRow = "_1g-9";
export var separator = "_1g-e";
export var shortcutContainer = "_1g-7";
export var shortcutContainerFilled = "_1g-8";
export var shortcutIconLg = "_1g-6";
export var shortcutIconMd = "_1g-5";
export var shortcutIconSm = "_1g-4";
export var submenuChevron = "_1g-d";
export var submenuDropdown = "_1g-a";
export var submenuTriggerRow = "_1g-b";
export var submenuTriggerRowOpen = "_1g-c";